import { APIHandler } from "utilities/apiHandler";

import { ActivationResponse } from "commonComponents/entity/credentials/Credentials/Credentials.api.types";

import { UserProfileResponse } from "entity/login/Login/Login.api.types";

import {
    Auth0ActivationResponse,
    type IFinalizeActivationRequest,
    type IUserActivationLinkRequest,
} from "./UserActivationPage.api.types";

export interface IUserActivationPageHandler {
    linkExisting: (request: IUserActivationLinkRequest) => Promise<ActivationResponse>;
    profile: (userId: number) => Promise<UserProfileResponse>;
    finalizeActivation: (request: IFinalizeActivationRequest) => Promise<Auth0ActivationResponse>;
}

export class UserActivationPageHandler implements IUserActivationPageHandler {
    async linkExisting(request: IUserActivationLinkRequest): Promise<ActivationResponse> {
        return await APIHandler("/api/Users/LinkExisting", {
            method: "PUT",
            data: request,
            responseType: ActivationResponse,
        });
    }

    async profile(userId: number): Promise<UserProfileResponse> {
        return await APIHandler("/api/Users/Profile", {
            method: "GET",
            data: { userId },
            responseType: UserProfileResponse,
        });
    }

    async finalizeActivation(
        request: IFinalizeActivationRequest,
    ): Promise<Auth0ActivationResponse> {
        return await APIHandler("/api/Users/FinalizeActivation", {
            method: "POST",
            data: request,
            responseType: Auth0ActivationResponse,
        });
    }
}

export const defaultUserActivationHandler = new UserActivationPageHandler();
